var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Vidle',{staticClass:"d-none",attrs:{"duration":_vm.idleTimeDuration,"reminders":[_vm.idleTimeReminder],"events":['mousedown', 'keydown', 'touchstart', 'touchend', 'scroll']},on:{"remind":_vm.handleRemind,"refresh":_vm.handleRefresh,"idle":_vm.handleIdle}})
}
var staticRenderFns = []

export { render, staticRenderFns }